import PersonalInfo from './pages/PersonalInfo';
import Settings from './pages/Settings';
import PhoneVerifForm from './components/PhoneVerifForm';
import React from 'react';

import './Profile.styles.scss';

const ProfileRouter: React.FC = () => {
  return (
    <div className="profile-router">
      <div>
        <PersonalInfo className="grid-card" />
      </div>

      <div>
        <Settings className="grid-card" />
      </div>

      <div>
        <PhoneVerifForm className="grid-card" />
      </div>
    </div>
  );
};

export default ProfileRouter;
